/*=========================================================================================
  File Name: moduleUserActions.js
  Description: User Module Actions
  ----------------------------------------------------------------------------------------
==============================*/
import userService from "../../../services/user.service"

export default {
  addUser({ dispatch }, params) {
    return userService.createUser(params)
      .then(response => {
        dispatch('alertSuccess', typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
      })
      .catch(error =>{
        if(Object.values(error.errors).length > 0){
          dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
        }
        else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
      })
  },
  updateUser({commit, dispatch}, data){
    return userService.updateUser(data)
      .then(response => {
        // commit('UPDATE_USER', data)
        dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
      })
      .catch(error => {
          if(typeof error.errors == 'object'){
              if(Object.values(error.errors).length > 0){
                  dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
              }
          }
        else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
      })
  },
  fetchUsers ({ commit, dispatch }, payload) {
    return userService.getUsers(payload)
      .then(response => {
        commit('SET_USERS', response.data.data)
        commit('SET_INFO_DB', {totalPage: response.data.last_page, totalRow: response.data.total})
        return Promise.resolve(response.data.data)
      })
      .catch(error =>{
        if(Object.values(error.errors).length > 0){
          dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
        }
        else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
      })
  },
  fetchUser ({dispatch}, id) {
    return userService.getUser(id)
      .then(response => {
        return Promise.resolve(response.data)
      })
      .catch(error =>{
        if(typeof error.errors == 'object'){
          if(Object.values(error.errors).length > 0){
            dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
          }
        }
        else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
      })
  },
    removeRecords({commit, dispatch}, ids){
      return userService.deleteUsers({cids: ids})
        .then(response => {
          dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
        })
        .catch(error =>{
          if(typeof error.errors == 'object'){
            if(Object.values(error.errors).length > 0){
              dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
            }
          }
          else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
        })
    },
    resetPassword({ commit, dispatch}, ids){
      return userService.resetPassword({'cids': ids})
        .then(response => {
          dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0]:response.message, { root: true });
        })
        .catch(error =>{
          if(Object.values(error.errors).length > 0){
            dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
          }
          else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
        })
    }
}
